import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    DeleteLifecyclePhase,
    setLifecyclePhaseActive,
    setLifecyclePhaseConfirmDelete,
    setLifecycleModelReload,
} from "client/store"
import {
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    Button,
    SpinnerIcon,
} from "client/components"

const ConfirmDeletePhase = () => {
    const phaseToDelete = useSelector((state: StoreType) => state.lifecycle.model.confirmDeletePhase)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    const onCancel = () => {
        dispatch(setLifecyclePhaseConfirmDelete(null))
    }

    const onConfirm = () => {
        setDeleteState(PENDING)
        DeleteLifecyclePhase(phaseToDelete.id).then(() => {
            setDeleteState(IDLE)
            dispatch(setLifecyclePhaseActive(null))
            dispatch(setLifecyclePhaseConfirmDelete(null))

            dispatch(setLifecycleModelReload(false))
            setTimeout(() => {
                dispatch(setLifecycleModelReload(true))
            }, 0)
        })
    }

    return (
        <ConfirmWrapper
            show={phaseToDelete !== null}
            onClose={onCancel}
        >
            <Confirm>
                <ConfirmTitle>{phaseToDelete && phaseToDelete.name}</ConfirmTitle>
                <ConfirmDescription>{lang.deletePhaseConfirm}</ConfirmDescription>

                <ConfirmBottom>
                    <Button row onClick={onCancel}>{lang.cancel}</Button>
                    <Button variant="success" row onClick={onConfirm}>
                        {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ConfirmDeletePhase
